import * as tslib_1 from "tslib";
import { EventDispatcher } from "@awayjs/core";
/**
 * Picks a 3d object from a view or scene by 3D raycast calculations.
 * Performs an initial coarse boundary calculation to return a subset of entities whose bounding volumes intersect with the specified ray,
 * then triggers an optional picking collider on individual renderable objects to further determine the precise values of the picking ray collision.
 *
 * @class away.pick.RaycastPicker
 */
var TraverserBase = (function (_super) {
    tslib_1.__extends(TraverserBase, _super);
    /**
     *
     */
    function TraverserBase() {
        var _this = _super.call(this) || this;
        var i;
        //setup defaults for all entity functions
        for (i = 0; i < TraverserBase.entityNames.length; i++)
            if (!_this[TraverserBase.entityNames[i]])
                _this[TraverserBase.entityNames[i]] = _this.applyEntity;
        //setup defaults for all renderable functions
        for (i = 0; i < TraverserBase.renderableNames.length; i++)
            if (!_this[TraverserBase.renderableNames[i]])
                _this[TraverserBase.renderableNames[i]] = _this.applyRenderable;
        return _this;
    }
    TraverserBase.addEntityName = function (name) {
        TraverserBase.entityNames.push(name);
        return name;
    };
    TraverserBase.addRenderableName = function (name) {
        TraverserBase.renderableNames.push(name);
        return name;
    };
    /**
     * Returns true if the current node is at least partly in the frustum. If so, the partition node knows to pass on the traverser to its children.
     *
     * @param node The Partition3DNode object to frustum-test.
     */
    TraverserBase.prototype.enterNode = function (node) {
        return true;
    };
    TraverserBase.prototype.dispose = function () {
        //TODO
    };
    /**
     *
     * @param entity
     */
    TraverserBase.prototype.applyEntity = function (entity) {
        //do nothing
    };
    /**
     *
     * @param entity
     */
    TraverserBase.prototype.applyRenderable = function (renderable) {
        //do nothing
    };
    return TraverserBase;
}(EventDispatcher));
export { TraverserBase };
TraverserBase.entityNames = new Array();
TraverserBase.renderableNames = new Array();



// WEBPACK FOOTER //
// ../dist/lib/base/TraverserBase.js